import React, { useRef, useEffect } from "react";
import "./Map.css";

import PinPointForm from "./PinPointForm";
import CesiumViewer from "./CesiumViewer";
import { db } from "../firebase";
import { set, ref, onValue, remove } from "firebase/database";
import {
  Entity,
  GeoJsonDataSource,
  // Viewer,
  // Cesium3DTileset,
  // KmlDataSource,
  // ImageryLayer,
  // CameraFlyTo,
} from "resium";
import {
  Color as CesiumColor,
  VerticalOrigin,
  PinBuilder,
  Cartesian2,
  Cartesian3,
  HeightReference,
  Math,
  // PolylineOutlineMaterialProperty,
  // Cesium3DTileFeature,
  // Resource,
  // defined,
  // CesiumTerrainProvider,
  // IonResource,
  // WebMapServiceImageryProvider,
  // WebMapTileServiceImageryProvider,
  // GeographicTilingScheme,
  // Rectangle,
  // Ion,
} from "cesium";
import { formConfigData } from "../formConfigData";

function Map() {
  const viewerRef = useRef();

  const addPinPointsButtonClickedRef = useRef(false);
  const updatePinPointsButtonClickedRef = useRef(false);
  const deletePinPointsButtonClickedRef = useRef(false);

  const selectedPointLongitudeRef = useRef("");
  const selectedPointLatitudeRef = useRef("");

  const isFirstRenderRef = useRef(true);

  const pinBuilder = new PinBuilder();

  //using useEffect to load all the pin points from database when the Map gets rendered for the very first time
  useEffect(() => {
    remove(ref(db, `/points`));
    console.log("done deleting")
    isFirstRenderRef.current = false;
    if (viewerRef.current && viewerRef.current.cesiumElement) {
      // console.log(viewerRef.current.cesiumElement);

      // Following two statements are applying "Bing Maps Aerial With Labels" imagery model as a default base layer
      var baseLayerPickerViewModel =
        viewerRef.current.cesiumElement.baseLayerPicker.viewModel;
      baseLayerPickerViewModel.selectedImagery =
        baseLayerPickerViewModel.imageryProviderViewModels[1];
      // ⚠️Delete the following commented code before production
      // Usage: To load the pin points from database
      // onValue(ref(db, "points/"), (snapshot) => {
      //   //You can uncomment the following line in future if Delete PinPoint button doesn't work in one click, but don't uncomment it before
      //   // viewerRef.current.cesiumElement.entities.removeAll();
      //   const points = snapshot.val();
      //   for (const uniqueId in points) {
      //     createPinPoint(
      //       points[uniqueId].lon,
      //       points[uniqueId].lat,
      //       points[uniqueId].relatedToLand,
      //       points[uniqueId].assetName,
      //       points[uniqueId].assetThreatRisk,
      //       points[uniqueId].assetProtectMethodAlready,
      //       points[uniqueId].assetProtectMethodSuggestion
      //     );
      //   }
      // });
    }
  }, []);
  

  //returns latitue, longitude, and height based on the user's mouse click on the map
  var getLocationFromScreenXY = (x, y) => {
    const scene = viewerRef.current.cesiumElement.scene;

    if (!scene) return;

    const ellipsoid = scene.globe.ellipsoid;
    const cartesian = scene.camera.pickEllipsoid(
      new Cartesian2(x, y),
      ellipsoid
    );
    if (!cartesian) return;
    const { latitude, longitude, height } =
      ellipsoid.cartesianToCartographic(cartesian);
    return { latitude, longitude, height };
  };

  // returns template of the cesium's entity description
  const getEntityDescriptionTemplate = (lat, lon, formAnswerData) => {
    var template = `<dl><dt><h3>( Latitude: ${lat.toFixed(
      7
    )}, Longitude: ${lon.toFixed(7)} )</h3></dt><hr>`;
    Object.keys(formConfigData).map((key, index) => {
      template += `<dt><h3>${formConfigData[key].question}</h3></dt>`;
      template += `<dd>${formAnswerData[key]}</dd><hr>`;
    });
    template += "</dl>";
    return template;
  };

  //create and return a new pin point on Terrain
  var createPinPoint = (lon, lat, formInputFields) => {
    if (lon === undefined && lat === undefined) return; //means not all required information provided

    var uniqueId =
      lon.toString().replace(".", "").replace("-", "") +
      lat.toString().replace(".", "").replace("-", "");
    if (viewerRef.current.cesiumElement.entities.getById(uniqueId)) {
      return;
      //means pin point already exists
    }
    try {
      return viewerRef.current.cesiumElement.entities.add({
        name: "Pin",
        description: getEntityDescriptionTemplate(lat, lon, formInputFields),
        position: Cartesian3.fromDegrees(lon, lat),
        billboard: {
          image: pinBuilder.fromColor(CesiumColor.ROYALBLUE, 48),
          heightReference: HeightReference.CLAMP_TO_GROUND,
          verticalOrigin: VerticalOrigin.BOTTOM,
        },
        isPinPoint: true,
        longitude: lon,
        latitude: lat,
        id: uniqueId,
        // assetName,
        // assetThreatRisk,
        // assetProtectMethodAlready,
        // assetProtectMethodSuggestion,
      });
    } catch (err) {
      console.log("Error while adding pin point to the Cesium Viewer:\n" + err);
    }
  };

  //write to database
  var writeEntityToDatabase = (lon, lat, formInputFields) => {
    // Removing special characters from the unique id
    var uniqueId =
      lon.toString().replace(".", "").replace("-", "") +
      lat.toString().replace(".", "").replace("-", "");

    formInputFields.lon = lon;
    formInputFields.lat = lat;
    set(ref(db, `/points/${uniqueId}`), formInputFields);
  };

  //delete an entity from database
  var deleteEntityFromDatabase = (lon, lat) => {
    var uniqueId =
      lon.toString().replace(".", "").replace("-", "") +
      lat.toString().replace(".", "").replace("-", "");

    remove(ref(db, `/points/${uniqueId}`));
  };
  var handleClick = (evt) => {
    var selectedEntity = viewerRef.current.cesiumElement.selectedEntity;
    if (
      selectedEntity &&
      selectedEntity.description &&
      selectedEntity.isPinPoint
    ) {
      selectedPointLongitudeRef.current = selectedEntity.longitude;
      selectedPointLatitudeRef.current = selectedEntity.latitude;

      if (
        updatePinPointsButtonClickedRef.current === true &&
        deletePinPointsButtonClickedRef.current === true
      ) {
        alert(
          "Please enable one Pin Point button at a time. Both Update and Delete buttons are selected"
        );
      } else if (updatePinPointsButtonClickedRef.current === true) {
        document.querySelector(".pin-form").classList.toggle("hide");
      } else if (deletePinPointsButtonClickedRef.current === true) {
        viewerRef.current.cesiumElement.entities.remove(selectedEntity);
        deleteEntityFromDatabase(
          selectedPointLongitudeRef.current,
          selectedPointLatitudeRef.current
        );
      }
      return;
    }

    if (addPinPointsButtonClickedRef.current === true) {
      let coords = getLocationFromScreenXY(evt.position.x, evt.position.y);
      if (!coords) {
        //means user clicked on some irrelevant place on the globe eg. The sky
        return;
      }
      var lon = Math.toDegrees(coords.longitude);
      var lat = Math.toDegrees(coords.latitude);

      selectedPointLongitudeRef.current = lon;
      selectedPointLatitudeRef.current = lat;

      document.querySelector(".pin-form").classList.toggle("hide");

      return;
    }
  };

  const handlePinPointFormAddSubmit = (event, formInputFields) => {
    event.preventDefault();

    createPinPoint(
      selectedPointLongitudeRef.current,
      selectedPointLatitudeRef.current,
      formInputFields
    );

    writeEntityToDatabase(
      selectedPointLongitudeRef.current,
      selectedPointLatitudeRef.current,
      formInputFields
    );
    document.querySelector(".pin-form").classList.toggle("hide");
  };

  const handlePinPointFormUpdateSubmit = (event, formInputFields) => {
    event.preventDefault();

    if (!viewerRef.current.cesiumElement.selectedEntity) {
      alert(
        "Please do not close the Right Window before clicking on the update Button.\nPlease try again"
      );
      return;
    }
    var lat = selectedPointLatitudeRef.current;
    var lon = selectedPointLongitudeRef.current;
    viewerRef.current.cesiumElement.selectedEntity.description._value =
      getEntityDescriptionTemplate(lat, lon, formInputFields);

    writeEntityToDatabase(
      selectedPointLongitudeRef.current,
      selectedPointLatitudeRef.current,
      formInputFields
    );
    document.querySelector(".pin-form").classList.toggle("hide");
  };

  function FeatureLayer(props) {
    if (props.type === "rivers") {
      var riverLayerSource = props.source;

      return (
        <GeoJsonDataSource
          data={riverLayerSource}
          clampToGround={true}
          //FillColor = {CesiumColor.GREEN}
          strokeWidth={5}
          stroke={CesiumColor.DARKBLUE}
        />
      );

      //console.log("DataSource Name :" + geodata._name);
    } else if (props.type === "boundary") {
      return (
        <GeoJsonDataSource
          data={props.source}
          clampToGround={true}
          //FillColor = {CesiumColor.GREEN}
          strokeWidth={5}
          fill={CesiumColor.FORESTGREEN.withAlpha(0.5)}
          stroke={CesiumColor.FORESTGREEN}
        />
      );
    } else {
      return <Entity />;
    }
  }

  return (
    <>
      <div className="map-container">
        <PinPointForm
          updatePinPointsButtonClickedRef={updatePinPointsButtonClickedRef}
          handlePinPointFormAddSubmit={handlePinPointFormAddSubmit}
          handlePinPointFormUpdateSubmit={handlePinPointFormUpdateSubmit}
        />
        <CesiumViewer
          viewerRef={viewerRef}
          addPinPointsButtonClickedRef={addPinPointsButtonClickedRef}
          updatePinPointsButtonClickedRef={updatePinPointsButtonClickedRef}
          deletePinPointsButtonClickedRef={deletePinPointsButtonClickedRef}
          handleClick={handleClick}
        />
      </div>
    </>
  );
}

export default Map;
